import React from 'react';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';

interface QuantityInputProps {
	control: any;
	name: string;
	unitValue?: number;
	defaultValue?: number | string;
	placeholder: string;
	isInvalid?: boolean;
}

export default function QuantityInput({
	control,
	name,
	unitValue,
	defaultValue,
	placeholder,
	isInvalid
}: QuantityInputProps) {
	const isUnits = Number(unitValue) === 3;

	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ value, onChange }) => (
				<NumberFormat
					customInput={Form.Control}
					value={value ?? ''}
					placeholder={placeholder}
					maxLength={5}
					inputMode={isUnits ? 'numeric' : 'decimal'}
					thousandSeparator={false}
					decimalSeparator=","
					decimalScale={isUnits ? 0 : 2}
					fixedDecimalScale={!isUnits}
					allowNegative={false}
					isInvalid={isInvalid}
					onValueChange={({ floatValue, value: numericValue }) =>
						onChange(numericValue === '' ? '' : floatValue)
					}
				/>
			)}
		/>
	);
}
